// historyUi.js

function fmt(v) {
    if (v === null || v === undefined) return '—';
    if (typeof v === 'string') return v;
    if (typeof v === 'number' || typeof v === 'boolean') return String(v);
    try {
        return JSON.stringify(v);
    } catch {
        return String(v);
    }
}

export function flattenDiff(diff) {
    const rows = [];
    if (!diff) return rows;

    // rentalOrder.*
    const ro = diff.rentalOrder || {};
    Object.keys(ro).forEach((k) => {
        const ch = ro[k];
        rows.push({
            field: `rentalOrder.${k}`,
            oldValue: fmt(ch && ch.from),
            newValue: fmt(ch && ch.to),
        });
    });

    // snapshots.<group>.<path>
    const snaps = diff.snapshots || {};
    Object.keys(snaps).forEach((group) => {
        const changes = snaps[group] || {};
        Object.keys(changes).forEach((path) => {
            const ch = changes[path];
            rows.push({
                field: `snapshots.${group}.${path}`,
                oldValue: fmt(ch && ch.from),
                newValue: fmt(ch && ch.to),
            });
        });
    });

    // extras / insurances
    ['extras', 'insurances'].forEach((name) => {
        const d = diff[name];
        if (!d) return;

        (d.added || []).forEach((item) => {
            rows.push({ field: `${name}[+]`, oldValue: '—', newValue: fmt(item) });
        });
        (d.removed || []).forEach((item) => {
            rows.push({ field: `${name}[-]`, oldValue: fmt(item), newValue: '—' });
        });
        (d.updated || []).forEach((u) => {
            if (u && u.changes && Object.keys(u.changes).length) {
                Object.keys(u.changes).forEach((k) => {
                    const ch = u.changes[k];
                    rows.push({
                        field: `${name}[${u.key}].${k}`,
                        oldValue: fmt(ch && ch.from),
                        newValue: fmt(ch && ch.to),
                    });
                });
            } else {
                rows.push({
                    field: `${name}[${u && u.key}]`,
                    oldValue: fmt(u && u.from),
                    newValue: fmt(u && u.to),
                });
            }
        });
    });

    return rows;
}

export function getStatusChange(diff) {
    const s = diff && diff.rentalOrder && diff.rentalOrder.status;
    if (!s) return null;
    return { from: s.from, to: s.to };
}

export function prettyField(field) {
    const map = {
        'rentalOrder.status': 'Status',
        'rentalOrder.startDate': 'Start date',
        'rentalOrder.endDate': 'End date',
        'rentalOrder.startTime': 'Start time',
        'rentalOrder.endTime': 'End time',
        'rentalOrder.supplierId': 'Supplier',
        'rentalOrder.referenceNumber': 'Reference #',
        'rentalOrder.totalPriceCents': 'Total price (cents)',
        'rentalOrder.prepaymentAmountCents': 'Prepayment (cents)',
    };
    return map[field] || field;
}

export function badgeVariant(actionType) {
    if (actionType === 'CREATE') return 'success';
    if (actionType === 'UPDATE') return 'primary';
    return 'secondary';
}

export function formatTime(iso) {
    return new Date(iso).toLocaleString();
}
